/* VV reveal: sections rise in as they enter the viewport. One class, one transition, nothing on reduced motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var targets = document.querySelectorAll('.shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group) > *:first-child, .vv-faq__item, .cstm-product-card, .vb-vrtx-card, .sec-6-rebounder-card');
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('vv-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  targets.forEach(function (el, i) {
    if (el.getBoundingClientRect().top < window.innerHeight * 0.9) { el.classList.add('vv-in'); return; }
    el.classList.add('vv-reveal'); io.observe(el);
  });
})();

/* VV drag-scroll: mouse drag on horizontal tracks (thumbnails). Touch scrolls natively. */
(function () {
  document.querySelectorAll('.modern-gallery__thumbnails-track').forEach(function (track) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft; track.classList.add('is-dragging'); });
    track.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = startLeft - dx; });
    function up() { down = false; track.classList.remove('is-dragging'); }
    track.addEventListener('pointerup', up); track.addEventListener('pointerleave', up); track.addEventListener('pointercancel', up);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && track.scrollWidth > track.clientWidth) { track.scrollLeft += e.deltaY; e.preventDefault(); } }, { passive: false });
  });
})();
